<template>
  <div class="animated fadeIn">
    <v-col cols="12">
      <v-dialog v-model="confirm" max-width="600px">
        <!-- NOTE INJA -->
        <v-card>
          <v-card-title>
            <span>رد کردن فرم</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              شما درحال رد کردن فرم
              <strong>{{
                selectedForm.name + " " + selectedForm.lastName
              }}</strong>
              هستید‌، آیا از این کار مطمئنید؟
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="confirm = false"> خیر </v-btn>
            <v-btn
              :disabled="btnBusy"
              color="primary"
              outlined
              @click="doDeactive()"
            >
              بله
            </v-btn>
          </v-card-actions>
        </v-card>
        <!-- NOTE TA INJA -->
      </v-dialog>
      <v-dialog v-model="detailsDialog" max-width="600px">
        <!-- NOTE INJA -->
        <v-card>
          <v-card-title>
            <span>جزییات فرم</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <div class="text-center" v-if="busy">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  class="align-middle"
                ></v-progress-circular>
              </div>
              <div id="form" v-else>
                <v-row>
                  <v-col> زمینه همکاری: {{ selectedForm.field }} </v-col>
                </v-row>
                <h4 class="text-center text-primary my-4">مشخصات فردی</h4>
                <v-row>
                  <v-col> نام: {{ selectedForm.name }} </v-col>
                  <v-col> نام خانوادگی: {{ selectedForm.lastName }} </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    جنسیت: {{ selectedForm.gender == "male" ? "مرد" : "زن" }}
                  </v-col>
                  <v-col>
                    وضعیت تاهل:
                    {{ selectedForm.marriage == "single" ? "مجرد" : "متاهل" }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col> کد ملی: {{ selectedForm.natCode }} </v-col>
                  <v-col> محل تولد: {{ selectedForm.birthCity }} </v-col>
                </v-row>
                <v-row align="center">
                  <v-col> تاریخ تولد: {{ selectedForm.birthDate }} </v-col>
                  <v-col> سن: {{ selectedForm.age }} </v-col>
                </v-row>
                <v-row>
                  <v-col> تعداد فرزندان: {{ selectedForm.children }} </v-col>
                  <v-col>
                    تعداد افراد تحت تکفل: {{ selectedForm.custody }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col> شماره تلفن همراه: {{ selectedForm.mobile }} </v-col>
                  <v-col> شماره تلفن ثابت: {{ selectedForm.phone }} </v-col>
                </v-row>
                <v-row>
                  <v-col> آدرس محل سکونت: {{ selectedForm.address }} </v-col>
                </v-row>
                <v-row>
                  <v-col> نوع محل سکونت: {{ selectedForm.homeStatus }} </v-col>
                </v-row>
                <v-row>
                  <v-col> ایمیل: {{ selectedForm.email }} </v-col>
                </v-row>
                <hr />
                <h4 class="text-center text-primary my-4">سوابق تحصیلی</h4>
                <v-row>
                  <v-col>
                    آخرین مقطع تحصیلی: {{ selectedForm.latestDegree }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    اطلاعات تحصیلی
                    <b-table
                      responsive
                      show-empty
                      head-variant="light"
                      :fields="educationFields"
                      :items="selectedForm.education"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                    </b-table>
                  </v-col>
                </v-row>
                <hr />
                <h4 class="text-center text-primary my-4">سوابق کاری</h4>
                <v-row>
                  <v-col>
                    میزان سابقه کار: {{ selectedForm.experience }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    اطلاعات سوابق کاری
                    <b-table
                      responsive
                      show-empty
                      head-variant="light"
                      :fields="jobFields"
                      :items="selectedForm.jobs"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                      <template v-slot:cell(salary)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ Number(data.value).toLocaleString() }}
                        </div>
                      </template>
                    </b-table>
                  </v-col>
                </v-row>
                <hr />
                <v-row>
                  <v-col>
                    حقوق درخواستی(﷼):
                    {{ Number(selectedForm.salary).toLocaleString() }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    تاریخ ارسال فرم:
                    {{ selectedForm.date.split(" ")[0] }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    ساعت ارسال فرم:
                    {{ selectedForm.date.split(" ")[1] }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col> یادداشت: {{ selectedForm.notes }} </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="detailsDialog = false">
              بستن
            </v-btn>
            <v-btn v-if="!busy" color="primary" outlined @click="printForm()">
              پرینت
            </v-btn>
          </v-card-actions>
        </v-card>
        <!-- NOTE TA INJA -->
      </v-dialog>
      <v-dialog v-model="notesDialog" persistent max-width="600px">
        <!-- NOTE INJA -->
        <v-card>
          <v-card-title>
            <span>یادداشت فرم</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <div class="text-center" v-if="busy">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  class="align-middle"
                ></v-progress-circular>
              </div>
              <div v-else>
                <v-card>
                  <v-container>
                    یادداشت فعلی: {{ selectedForm.notes }}
                  </v-container>
                </v-card>
                <v-textarea
                  class="mt-3"
                  outlined
                  label="یادداشت جدید"
                  v-model="note"
                >
                </v-textarea>
              </div>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="notesDialog = false">
              بستن
            </v-btn>
            <v-btn
              v-if="!busy"
              :loading="btnBusy"
              color="primary"
              outlined
              @click="changeNote()"
            >
              ثبت
            </v-btn>
          </v-card-actions>
        </v-card>
        <!-- NOTE TA INJA -->
      </v-dialog>
      <v-card>
        <v-card-title>
          <v-row>
            <v-col>فرم‌های فعال</v-col>
          </v-row>
        </v-card-title>
        <v-row class="mt-2 me-3">
          <v-col cols="8"> </v-col>
          <v-col cols="2">
            <vue-excel-xlsx
              depressed
              :class="computedForms.length ? 'white--text' : 'disabled-excel'"
              class="darkGreen-mainBtn mb-2 float-end"
              style="width: 135px; height: 35px;"
              :data="excelItems"
              :columns="excelFormFields"
              :filename="'لیست فرم‌های فعال'"
              :sheet-name="'لیست فرم‌های فعال'"
              ><div
                :class="
                  computedForms.length ? 'white--text' : 'disabled-excel-icon'
                "
              >
                <v-icon
                  class="me-1"
                  :class="
                    computedForms.length ? 'white--text' : 'disabled-excel-icon'
                  "
                >
                  mdi-file-excel-outline </v-icon
                >خروجی اکسل
              </div>
            </vue-excel-xlsx>
          </v-col>
          <v-col cols="2">
            <v-btn
              :disabled="gettingReceipt || !computedForms.length"
              class="darkRed-mainBtn white--text "
              style="width: 135px; height: 35px"
              @click="printReceipt()"
              depressed
              ><v-icon class="me-1">mdi-printer</v-icon> پرینت</v-btn
            >
          </v-col>
        </v-row>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-text-field
                  dense
                  outlined
                  v-model="Filter"
                  append-icon="mdi-magnify"
                  label="جستجو"
                  hide-details
                  class="text-right w-80 mb-2"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-select
                  dense
                  outlined
                  :items="fields"
                  v-model="field"
                ></v-select>
              </v-col>
            </v-row>
            <b-table
              responsive
              show-empty
              head-variant="light"
              :fields="formFields"
              :items="computedForms"
              empty-text="رکوردی برای نمایش وجود ندارد"
              empty-filtered-text="رکوردی برای نمایش وجود ندارد"
              :busy="isBusy"
              :filter="Filter"
              :current-page="CurrentPage"
              :per-page="PerPage"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(name&last)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.item.name + " " + data.item.lastName }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + PerPage * (CurrentPage - 1) + 1 }}
                </div>
              </template>
              <template v-slot:cell(gender)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value == "male" ? "مرد" : "زن" }}
                </div>
              </template>
              <template v-slot:cell(salary)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ Number(data.value).toLocaleString() }}
                </div>
              </template>
              <template #cell(show_details)="row">
                <div style="text-align: center; vertical-align: middle">
                  <v-btn
                    color="primary"
                    @click="row.toggleDetails"
                    class="mr-2"
                  >
                    {{ row.detailsShowing ? "بستن" : "باز" }}
                  </v-btn>
                </div>
              </template>

              <template #row-details="row">
                <div style="text-align: center; vertical-align: middle">
                  <v-btn
                    class="m-1"
                    outlined
                    color="black"
                    @click="openForm(row.item)"
                    >جزییات</v-btn
                  >
                  <v-btn
                    class="m-1"
                    outlined
                    color="green"
                    @click="gotoEditForm(row.item)"
                    >ویرایش</v-btn
                  >
                  <v-btn
                    color="red"
                    :loading="btnBusy"
                    class="m-1"
                    outlined
                    @click="deactiveForm(row.item)"
                    >رد کردن</v-btn
                  >
                  <v-btn
                    color="purple"
                    class="m-1"
                    outlined
                    @click="openNotes(row.item)"
                    >یادداشت</v-btn
                  >
                </div>
              </template>
              <div slot="table-busy" class="text-center text-primary my-2">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  class="align-middle"
                ></v-progress-circular>
              </div>
            </b-table>
            <v-pagination
              v-model="CurrentPage"
              :length="Math.ceil(TotalRows / PerPage)"
              :total-visible="5"
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
            ></v-pagination>
            <v-select
              label="تعداد در هر صفحه:"
              style="width: 150px"
              v-model="PerPage"
              :items="perPageOptions"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-container>
        </v-card-text>
      </v-card>
    </v-col>
    <div v-show="false" id="printTable">
      <h3>فرم‌های فعال</h3>
      <b-table :fields="formFieldsPrint" :items="computedForms">
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(name&last)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.item.name + " " + data.item.lastName }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 }}
          </div>
        </template>
        <template v-slot:cell(gender)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value == "male" ? "مرد" : "زن" }}
          </div>
        </template>
        <template v-slot:cell(salary)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ Number(data.value).toLocaleString() }}
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>
<script>
import Axios from "axios";
import router from "../../router";

export default {
  data() {
    return {
      printInvoice: {},
      gettingReceipt: false,
      CurrentPage: 1,
      PerPage: 10,
      perPageOptions: [
        { value: 10, text: "10" },
        { value: 25, text: "25" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
      ],
      TotalRows: "",
      Filter: "",
      isBusy: true,
      busy: true,
      btnBusy: false,
      sendBusy: false,
      getExcel: false,
      formFields: [
        { key: "index", label: "#" },
        { key: "name&last", label: "نام و نام خانوادگی" },
        { key: "gender", label: "جنسیت" },
        { key: "age", label: "سن" },
        { key: "latestDegree", label: "آخرین مقطع تحصیلی" },
        { key: "experience", label: "میزان سابقه کار" },
        { key: "salary", label: "حقوق درخواستی" },
        { key: "notes", label: "یادداشت" },
        { key: "show_details", label: "عملیات" },
      ],
      formFieldsPrint: [
        { key: "index", label: "#" },
        { key: "name&last", label: "نام و نام خانوادگی" },
        { key: "gender", label: "جنسیت" },
        { key: "age", label: "سن" },
        { key: "latestDegree", label: "آخرین مقطع تحصیلی" },
        { key: "experience", label: "میزان سابقه کار" },
        { key: "salary", label: "حقوق درخواستی" },
        { key: "notes", label: "یادداشت" },
      ],
      excelFormFields: [
        { field: "name", label: "نام" },
        { field: "lastName", label: "نام خانوادگی" },
        { field: "gender", label: "جنسیت" },
        { field: "natCode", label: "کدملی" },
        { field: "experience", label: "میزان سابقه کار" },
        { field: "field", label: "زمینه همکاری" },
        { field: "salary", label: "حقوق درخواستی" },
        { field: "birthCity", label: "محل تولد" },
        { field: "birthDate", label: "تاریخ تولد" },
        { field: "age", label: "سن" },
        { field: "latestDegree", label: "آخرین مقطع تحصیلی" },
        { field: "marriage", label: "وضعیت تاهل" },
        { field: "children", label: "تعداد فرزند" },
        { field: "custody", label: "تعداد افراد تحت تکلف" },
        { field: "phone", label: "تلفن ثابت" },
        { field: "mobile", label: "تلفن همراه" },
        { field: "address", label: "آدرس" },
        { field: "email", label: "ایمیل" },
        { field: "homeStatus", label: "نوع محل سکونت" },
        { field: "notes", label: "یادداشت" },
      ],
      excelItems: [],
      educationFields: [
        { key: "index", label: "#" },
        { key: "grade", label: "مقطع" },
        { key: "start", label: "سال شروع" },
        { key: "end", label: "سال پایان" },
        { key: "university", label: "دانشگاه" },
        { key: "major", label: "رشته" },
      ],
      jobFields: [
        { key: "index", label: "#" },
        { key: "company", label: "نام شرکت" },
        { key: "position", label: "سمت" },
        { key: "start", label: "سال شروع" },
        { key: "end", label: "سال پایان" },
        { key: "salary", label: "حقوق دریافتی(﷼)" },
        { key: "reason", label: " دلیل ترک کار" },
      ],
      field: "همه",
      fields: ["همه", "کارشناس بازرگانی", "منشی", "امور مالی"],
      Items: [],
      detailsDialog: false,
      notesDialog: false,
      confirm: false,
      confirmSend: false,
      note: "",
      selectedForm: {},
    };
  },
  computed: {
    computedForms() {
      let filtered = this.Items;
      if (this.field == "همه") {
        return filtered;
      } else {
        filtered = this.Items.filter((x) => x.field == this.field);
      }
      return filtered;
    },
  },
  methods: {
    print(item) {
      this.gettingReceipt = true;
      Axios.post({
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
      })
        .then((res) => {
          this.gettingReceipt = false;
          if (res.status == 200) {
            this.printInvoice = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .then(() => {
          setTimeout(() => {
            this.printReceipt();
          }, 400);
        })
        .catch((err) => {
          console.log(err);
          this.gettingReceipt = false;
          this.toast(err.response.data, "error");
        });
    },
    printReceipt() {
      //printing receipt
      var myWindow = window.open("#", "printTable", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><style>body{font-size: 16px;font-family:B Nazanin;} table, td, th {border: 1px solid black} tr{ page-break-inside:avoid; page-break-after:auto } thead { display: table-header-group;} table{border-collapse: collapse; direction: rtl; font-size:16px; width:100%}</style><title></title>"
      );
      myWindow.document.write("</head><body>");
      myWindow.document.write(document.getElementById("printTable").innerHTML);
      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
    printForm() {
      this.$htmlToPaper("form");
    },
    gotoEditForm(item) {
      router.push("/hrm/editForm/" + item.id);
    },
    deactiveForm(item) {
      this.selectedForm = item;
      this.confirm = true;
    },
    doDeactive() {
      this.btnBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/hr/form/deactive",
        {
          formId: this.selectedForm.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.btnBusy = false;
          if (res.status == 200) {
            this.toast("فرم با موفقیت رد شد", "success");
            this.confirm = false;
            this.showActiveForms();
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.btnBusy = false;
        });
    },
    openForm(item) {
      this.selectedForm = {};
      this.detailsDialog = true;
      this.busy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/hr/form/getInfo",
        {
          formId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.busy = false;
          if (res.status == 200) {
            this.selectedForm = res.data;
            this.selectedForm.jobs = JSON.parse(this.selectedForm.jobs);
            this.selectedForm.education = JSON.parse(
              this.selectedForm.education
            );
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.busy = false;
        });
    },
    openNotes(item) {
      this.selectedForm = {};
      this.note = "";
      this.notesDialog = true;
      this.busy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/hr/form/getInfo",
        {
          formId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.busy = false;
          if (res.status == 200) {
            this.selectedForm = res.data;
            this.selectedForm.id = item.id;
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.busy = false;
        });
    },
    changeNote() {
      this.btnBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/hr/form/edit",
        {
          formId: this.selectedForm.id,
          notes: this.note,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.btnBusy = false;
          if (res.status == 200) {
            this.toast("یادداشت با موفقیت ویرایش شد", "success");
            this.notesDialog = false;
            this.showActiveForms();
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.btnBusy = false;
        });
    },
    showActiveForms() {
      //NOTE set reception data when page mount
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/hr/forms/actives",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.Items = res.data;
            this.TotalRows = this.Items.length;
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.isBusy = false;
        });
    },
    formsOutput() {
      //NOTE getting patients excel
      this.getExcel = true;
      Axios.post(
        this.baseUrl + "/ppkpms/hr/forms/activesExcel",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.excelItems = res.data;
            this.getExcel = false;
            setTimeout(() => {
              this.$refs.excelBtn.$el.click();
            }, 300);
          } else {
            this.$notify({
              type: "error",
              group: "error",
              title: "خطا",
              text: "مشکلی پیش آمده. مجددا امتحان کنید.",
            });
            this.getExcel = false;
          }
        })
        .catch((err) => {
          this.$notify({
            type: "error",
            group: "error",
            title: "خطا",
            text: "خطا: " + err.response.data,
          });
          this.getExcel = false;
        });
    },
  },

  mounted() {
    this.showActiveForms();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
.app-body {
  overflow-x: unset !important;
}
</style>
